import useStorage from '@klv/hooks/useStorage';

const STORED_VOTES_KEY = 'klv-hc-votes';
const STORED_FEEDBACK_KEY = 'klv-hc-feedback';

export const useStoredVotes = (articleId: string) => {
  const [storedVotes, setStoredVotes] = useStorage(STORED_VOTES_KEY, {}, 'sessionStorage');

  const vote = storedVotes?.[articleId] ? storedVotes[articleId] : 0;

  const setVote = (value: number) => {
    if (!storedVotes) return false;
    const newVotes = {
      ...storedVotes,
      [articleId]: value,
    };
    setStoredVotes(newVotes);
  };

  return {
    storedVotes,
    setVote,
    vote,
  };
};

export const useStoredFeedback = (articleId: string) => {
  const [storedFeedback, setStoredFeedback] = useStorage(STORED_FEEDBACK_KEY, {}, 'sessionStorage');

  const hasFeedback = storedFeedback?.[articleId] ? storedFeedback[articleId] : 0;

  const storeFeedback = () => {
    if (!storedFeedback) return false;
    const newVotes = {
      ...storedFeedback,
      [articleId]: true,
    };
    setStoredFeedback(newVotes);
  };

  return {
    storeFeedback,
    hasFeedback,
  };
};
